class PollSubmit {
  init() {
    jQuery(window).on('load', () => {
      this.submitOnChange();
      this.setPollWidth();
    });

    jQuery(document).on('ajaxComplete', () => {
      this.setPollWidth();
      this.submitOnChange();
    });
  }

  submitOnChange() {
    const choice = jQuery('.poll').find('.form-item-choice input');

    choice.on('change', (e) => {
      const form = jQuery(e.target).closest('form');
      const voteBtn = form.find('.form-submit');
      voteBtn.trigger('mousedown');
    });
  }

  setPollWidth() {
    jQuery('.poll .foreground').each((index, el) => {
      const element = jQuery(el);
      const width = element.attr('data-width');

      setTimeout(() => {
        element.width(width);
      }, 500);
    });
  }
}

export default PollSubmit;
